<mat-toolbar [class.darkHeader]="community?.dark_header || isDarkMode"
             class="d-flex mat-elevation-z3 flex-space-between navbar main-header">
    <mat-toolbar-row *ngIf="this.user?.hijacked">
        <div class="hijackBar"><p>You are viewing the Explain Communities platform
            as {{ this.user?.username }} </p>
            <button (click)="logout()" (keyup.enter)="logout()" aria-label="Log Out" mat-mini-fab
                    matTooltip="Log Out">
                <mat-icon>exit_to_app</mat-icon>
            </button>
        </div>
    </mat-toolbar-row>
    <mat-toolbar-row class="flex-space-between">
        <div class="flex-row align-items-center h-100 gap-10">
            <div>
                <button *ngIf="companyImg && community?.logo_position == 'left' && ! community?.hide_logo_in_navbar"
                        [routerLink]="[!community?.default_page_is_feed? '/dashboard' : '/feed']"
                        aria-label="Feed"
                        class="logoBg logoBtn" mat-icon-button matTooltip="My Feed">
                    <img [src]="companyImg" class="companyImg">
                </button>
            </div>
            <div class="flex-row tabStyle align-items-end h-100 gap-10">
                <button
                        [appCustomButtonColours]="(community?.dashboard_button_color_hex ?? ((community?.dark_header || isDarkMode)? 'white' : 'black'))"
                        [routerLinkActive]="'tabSelected'" [routerLink]="['/dashboard']"
                        class="smTabletHidden fill-button" disableRipple
                        mat-button>
                    Dashboard
                </button>
                <button [appCustomButtonColours]="(community?.main_feed_button_color_hex ?? ((community?.dark_header || isDarkMode)? 'white' : 'black'))"
                        [appCustomRouterLinkActive]="'tabSelected'" [customCondition]="isMainFeed"
                        [routerLink]="['/feed']" class="smTabletHidden fill-button" disableRipple
                        mat-button>
                    Main Feed
                </button>
                <ng-container *ngFor="let group of subgroups; let i = index">
                    <button [appCustomButtonColours]="(group.button_color_hex ?? ((community?.dark_header || isDarkMode)? 'white' : 'black'))"
                            [appCustomRouterLinkActive]="'tabSelected'"
                            [customCondition]="isSubgroupFeed"
                            [dynamicParamForCondition]="group.id"
                            [queryParams]="{ subgroup: group.id }" [routerLink]="['/feed']"
                            [style.font-family]="group.item_header_text_font?.name"
                            class="lgTabletHidden fill-button" disableRipple
                            mat-button>{{ group.name }}
                    </button>
                </ng-container>
                <ng-container *ngIf="subgroupsMenuList.length">
                    <button [appCustomButtonColours]="(community?.dark_header || isDarkMode)? 'white' : 'black'"
                            [matMenuTriggerFor]="subgroupsMenu" class="lgTabletHidden fill-button" disableRipple
                            mat-button>
                        Show more
                    </button>
                    <mat-menu #subgroupsMenu="matMenu">
                        <button *ngFor="let group of subgroupsMenuList; let i = index"
                                [queryParams]="{ subgroup: group.id }"
                                [routerLink]="['/feed']"
                                [style.font-family]="group.item_header_text_font?.name"
                                mat-menu-item>
                            {{ group.name }}
                        </button>
                    </mat-menu>
                </ng-container>
            </div>
        </div>
        <div class="d-flex align-items-center">
            <app-header-community-selector class="lgTabletHidden"/>
            <app-header-notifications *ngIf="!isApp"/>

            <button (click)="settings()" aria-label="Settings" class="initialBtn"
                    mat-button matTooltip="Profile settings">
                <div [appUserAvatar]="currentUser" class="initial">
                </div>
                <span [style.color]="community?.profile_username_text_color_hex"
                      class="smTabletHidden">{{ currentUserName }}</span>
            </button>
            <button #menuOption="matMenuTrigger" [matMenuTriggerFor]="menu" aria-label="Menu"
                    (menuOpened)="menuOption.menuOpen" (menuClosed)="menuOption.menuOpen"

                    class="tabletShow show"
                    mat-icon-button matTooltip="More menu items">
                <i>
                    <svg viewBox="0 0 100 80" width="40" height="40"
                         [@openClose]="menuOption.menuOpen ? 'open' : 'closed'"
                         (@openClose.done)="onAnimationDone(menuOption.menuOpen)" [class.openedBurger]="menuOpen">
                        <rect width="100" height="10" rx="8"></rect>
                        <rect y="30" width="100" height="10" rx="8"></rect>
                        <rect y="60" width="100" height="10" rx="8"></rect>
                    </svg>
                </i>
            </button>
            <mat-menu #menu="matMenu">
                <button [routerLink]="['/dashboard']" class="smTabletShow" mat-menu-item>
                    Dashboard
                </button>
                <button [routerLink]="['/feed']" class="smTabletShow" mat-menu-item>
                    Main feed
                </button>
                <app-header-community-selector class="tabletShow"/>
                <button *ngIf="subgroups.length > 0" [matMenuTriggerFor]="subGroupsMenuMobile" class="d-flex tabletShow"
                        mat-menu-item>
                    <span>Subgroups</span>
                </button>
                <button (click)="settings()" mat-menu-item>
                    <span>My settings</span>
                </button>
                <ng-container *ngIf="isMobile">
                    <button (click)="openProfile()" mat-menu-item>
                        <span>My profile</span>
                    </button>
                    <button (click)="openRecentActivity()" mat-menu-item>
                        <span>Recent activity</span>
                    </button>
                    <button (click)="openPointsLeaderboard()" *ngIf="community?.show_points" mat-menu-item>
                        <span>Points leaderboard</span>
                    </button>
                </ng-container>
                <button (click)="openBadges()" *ngIf="community?.badges_active && hasCommunityRole(['member'])"
                        mat-menu-item>
                    <span>Badges</span>
                </button>
                <button (click)="openLevels()" *ngIf="community?.levels_active && hasCommunityRole(['member'])"
                        mat-menu-item>
                    <span>Levels</span>
                </button>

                <button *ngIf="community?.terms_and_conditions" [routerLink]="['/terms-and-conditions']" mat-menu-item>
                    <span>Terms & conditions</span>
                </button>
                <button *ngIf="community?.privacy_policy" [routerLink]="['/privacy-policy']" mat-menu-item>
                    <span>Privacy policy</span>
                </button>
                <button [routerLink]="['/contact']" mat-menu-item>
                    <span>Contact us</span>
                </button>
                <ng-container *ngFor="let item of listItems">
                    <button [routerLink]="['/info', item.id]" mat-menu-item>
                        {{ item.title }}
                    </button>
                </ng-container>
                <button [routerLink]="['/communicationPreferences']" mat-menu-item>
                    <span>Communication preferences</span>
                </button>
                <button *ngIf="isSuperuser || hasCommunityRole(['full_admin'])" [routerLink]="['/admin']" mat-menu-item>
                <span [style.color]="community?.admin_panel_button_highlight_color_hex"
                      class="accent-color">Admin panel</span>
                </button>
                <button *ngIf="hasCommunityRole(['reports_only'])" [routerLink]="['/reports']" mat-menu-item>
                    Reports
                </button>
                <button (click)="logout()" mat-menu-item>
                    <mat-icon>exit_to_app</mat-icon>
                    <span>Log out</span>
                </button>
            </mat-menu>

            <button *ngIf="companyImg && community?.logo_position == 'right'"
                    [routerLink]="[!community?.default_page_is_feed? '/dashboard' : '/feed']"
                    aria-label="Feed"
                    class="logoBg" mat-icon-button matTooltip="My feed">
                <img [src]="companyImg" class="companyImg">
            </button>
        </div>
    </mat-toolbar-row>
</mat-toolbar>

<mat-menu #subGroupsMenuMobile="matMenu">
    <button *ngFor="let group of allSubgroups; let i = index" [queryParams]="{ subgroup: group.id }"
            [routerLink]="['/feed']"
            [style.font-family]="group.item_header_text_font?.name" mat-menu-item>
        {{ group.name }} {{ group.item_header_text_font?.name }}
    </button>
</mat-menu>
